import { apis } from '@doltech/core/lib/api/api.config';
import { BookDetail } from '../types';
import { apiPublicUrls } from '@doltech/core/lib/api/api.public-urls';

export const fetchPublicBookLandingById = async (id: string, token?: string) => {
  const { data } = await apis.publicPageManagement.get<BookDetail>(
    apiPublicUrls.pageManagement.GET_BOOK_LANDING_BY_ID,
    { id },
    token
      ? {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      : {}
  );
  return data;
};
